import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-third-parties-banner',
  templateUrl: './third-parties-banner.component.html',
  styleUrls: ['./third-parties-banner.component.scss']
})
export class ThirdPartiesBannerComponent {
  @Input() defaultImg?: string;
  @Input() srcLogo?: string;
  @Input() isLoading: boolean = false;
  @Input() isContextMenuVisible: boolean = true;
  @Output() fileUploaded = new EventEmitter<File | undefined>();
  @Output() fileDeleteClicked = new EventEmitter<void>();

  @ViewChild('imageInput') imageInput!: ElementRef;

  customMenuVisible: boolean = false;
  menuPosition: { x: number, y: number } = { x: 0, y: 0 };
  photoAllowedExt: any =  ['.png', '.jpg','.jpeg'];
  fileSize: any = 2097152; // convert 2MB to bytes ( 1,048,576 Bytes *2 )

  showCustomMenu(event: MouseEvent) {
    if (!this.isContextMenuVisible) {
      return;
    }
    event.preventDefault();
    this.customMenuVisible = true;
    this.menuPosition = { x:  event.offsetX, y: event.offsetY };
    document.addEventListener('click', () => {
      this.customMenuVisible = false;
    }, { once: true });
  }

  fetchImage(){
    if(this.isLoading){return}
    this.imageInput.nativeElement.click();
  }

  deleteImage(){
    this.fileDeleteClicked.emit();
  }

  uploadImage(event: any){
    const file = event.target.files[0];
    this.fileUploaded.emit(file);
  }

}
